import Vue from "vue";
import Vuetify from "vuetify/lib";
import BaseIcon from "@/components/BaseIcon.vue";
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#6D41F3",
        error: "#F03965",
        success: "#3BB54A"
        // accent: colors.shades.black,
        // error: colors.red.accent3,
      }
    }
  },
  icons: {
    values: {
      warning: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "warning"
        }
      },
      percentagegrey: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "percentagegrey"
        }
      },
      person: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "person"
        }
      },
      trenddown: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "trenddown"
        }
      },
      refresh: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "refresh"
        }
      },
      group: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "group"
        }
      },
      duplicate: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "duplicate"
        }
      },
      clock: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "clock"
        }
      },
      basketsimple: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "basketsimple"
        }
      },
      arrowleft: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "arrowleft"
        }
      },
      edit: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "edit"
        }
      },
      trash: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "trash"
        }
      },
      menudots: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "menudots"
        }
      },
      basketsimpleremove: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "basketsimpleremove"
        }
      },
      add: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "add"
        }
      },
      stock: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "stock"
        }
      },
      arrowup: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "arrowup"
        }
      },
      arrowdown: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "arrowdown"
        }
      },
      trendup: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "trendup"
        }
      },
      send: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "send"
        }
      },
      cursorpointer: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "cursorpointer"
        }
      },
      currencyexchange: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "currencyexchange"
        }
      },
      conversion: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "conversion"
        }
      },
      rounddollar: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "rounddollar"
        }
      },
      percentage: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "percentage"
        }
      },
      zoom: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "zoom"
        }
      },
      downarrow: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "downarrow"
        }
      },
      bell: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "bell"
        }
      },
      cogwheel: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "cogwheel"
        }
      },
      dashboard: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "dashboard"
        }
      },
      lifering: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "lifering"
        }
      },
      loan: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "loan"
        }
      },
      megaphone: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "megaphone"
        }
      },
      ranking: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "ranking"
        }
      },
      messagingg: {
        component: BaseIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          name: "messaging"
        }
      }
    }
  }
});
